import { render, staticRenderFns } from "./updateAdminUser.vue?vue&type=template&id=45608306&"
import script from "./updateAdminUser.vue?vue&type=script&lang=js&"
export * from "./updateAdminUser.vue?vue&type=script&lang=js&"
import style0 from "./updateAdminUser.vue?vue&type=style&index=0&id=45608306&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports